import { useEffect, useState } from 'preact/hooks'
import { hideModal } from 'helpers/dom'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { addCartItem, addMultipleCartItems, updateCart, updateCartItem } from 'libs/cart'
import TextInput from 'snippets/form/text-input/text-input'
import Image from 'snippets/image/image'
import Button from 'snippets/button/button'

const selectors = {
  ENGARAVING_MODAL_SELECTOR: 'engraving-product-modal'
}

const EngravingContentModal = ({ contentModal, productEngravingId, status, product, defautlEngraving, cartItem }) => {
  if (!Object.keys(contentModal).length) {
    return <></>
  }

  const [textEngraving, setTextEngraving] = useState(defautlEngraving)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const regex = /^[a-zA-Z0-9]+$/

  useEffect(() => {
    setTextEngraving(defautlEngraving)
  }, [defautlEngraving])

  useEffect(() => {
    if (status !== 'EditEngraving') {
      setTextEngraving('')
    }
  }, [status])

  const handleInputChange = (textValue) => {
    const validInput = regex.test(textValue)

    setTextEngraving(textValue)
    setIsError(!validInput)
  }

  const handleEditEngraving = async (product) => {
    setIsLoading(true)

    try {
      await updateCartItem(product.id, product.quantity, { ...product.properties, _engraving: textEngraving })
      await updateCartItem(cartItem.id, cartItem.quantity, { ...cartItem.properties, _engraving: textEngraving })

      const newCart = await updateCart()

      setIsLoading(false)
      setTextEngraving('')

      hideModal(selectors.ENGARAVING_MODAL_SELECTOR)
      globalEmitter.emit(emitterProps.cart.add, newCart)
    } catch (error) {
      console.warn(error)
      setIsLoading(false)
    }
  }

  const handleAddEngraving = async (product) => {
    const timestamp = new Date().getTime()
    const properties = {
      _timestamp: timestamp,
      _engraving: textEngraving
    }

    setIsLoading(true)

    try {
      await updateCartItem(product.id, product.quantity, { ...product.properties, ...properties })
      await addCartItem(productEngravingId, { ...properties, _isProductEngraving: true, _parentProductSku: product.sku }, product.quantity)

      const newCart = await updateCart()

      setIsLoading(false)
      setTextEngraving('')

      hideModal(selectors.ENGARAVING_MODAL_SELECTOR)
      globalEmitter.emit(emitterProps.cart.add, newCart)
    } catch (error) {
      console.warn(error)
      setIsLoading(false)
    }
  }

  const handleAddToCart = async (product) => {
    const timestamp = new Date().getTime()
    const properties = {
      _timestamp: timestamp,
      _engraving: textEngraving
    }
    const payload = {
      items: [
        {
          id: productEngravingId,
          quantity: 1,
          properties: {
            ...properties,
            _isProductEngraving: true,
            _parentProductSku: product.sku
          }
        },
        {
          id: product.id,
          quantity: product.quantity,
          properties
        }
      ]
    }

    setIsLoading(true)

    try {
      await addMultipleCartItems(payload)

      const newCart = await updateCart()

      setIsLoading(false)
      setTextEngraving('')

      hideModal(selectors.ENGARAVING_MODAL_SELECTOR)
      globalEmitter.emit(emitterProps.cart.add, newCart)
    } catch (error) {
      console.warn(error)
      setIsLoading(false)
    }
  }

  const attachEvent = (product) => {
    if (status === 'EditEngraving') {
      handleEditEngraving(product)
    } else if (status === 'AddEngraving') {
      handleAddEngraving(product)
    } else {
      handleAddToCart(product)
    }
  }

  return <>
    {contentModal?.image?.src && <div className="relative">
      <Image
        alt={contentModal.image.alt || 'image product'}
        imageUrl={[contentModal.image.src]}
        imageClass="w-full"
      />
      {textEngraving.length ? (
        <>
          <span
            className="text-xs-short text-engraving-text absolute block font-semibold uppercase md:text-sm-small"
            style={`top: ${contentModal?.textLeft?.y || '50%'}; left: ${contentModal?.textLeft?.x || '50%'}; color: ${contentModal.colorText}`}
          >
            {textEngraving.split('')[0]}
          </span>
          {textEngraving.split('')[1] && (
            <span
              className="text-xs-short text-engraving-text absolute block font-semibold uppercase md:text-sm-small"
              style={`top: ${contentModal?.textRight?.y || '50%'}; left: ${contentModal?.textRight?.x || '50%'}; color: ${contentModal.colorText}`}
            >
              {textEngraving.split('')[1]}
            </span>
          )}
        </>
      ) : (
        <></>
      )}
    </div>}
    <div className="px-4 py-6">
      <TextInput
        classWrap="w-full mb-2"
        className="uppercase p-3 placeholder:text-grey-600 placeholder:capitalize placeholder:text-xs"
        type="text"
        id="input-add-engraving"
        placeholder="Add Engraving"
        autocomplete={true}
        name="text-engraving"
        value={textEngraving}
        maxlength={contentModal?.limitCharacters || 2}
        showPlaceholderCustom={false}
        onInput={(e) => handleInputChange(e.target.value.toUpperCase())}
      />
      <div className="flex justify-between items-center gap-2">
        {isError && textEngraving.length ? <div className="text-error text-xs">Error - letters and numbers only</div> : <></>}
        <div className="ml-auto text-xs">Max {contentModal?.limitCharacters || 2} characters</div>
      </div>
      {contentModal?.description && <div className="mt-6 text-xs">{contentModal.description}</div>}
    </div>
    <div className="p-4 border-t border-grey-100 mt-auto">
      <Button className="button-primary w-full" text={contentModal?.modalCtaText || translate.product.madeToOrder} loading={isLoading} disabled={!textEngraving.length || isLoading || isError} onHandle={() => attachEvent(product)} />
    </div>
  </>
}

export default EngravingContentModal
